import { ImagePlus, X } from "lucide-react";

export const resizeImage = (file) => new Promise((resolve) => {
  const img = new Image();
  img.onload = () => {
    const scale = Math.min(1, 1200 / img.width);
    const c = document.createElement("canvas");
    c.width = img.width * scale;
    c.height = img.height * scale;
    c.getContext("2d").drawImage(img, 0, 0, c.width, c.height);
    resolve(file.type === "image/png" ? c.toDataURL("image/png") : c.toDataURL("image/jpeg", 0.8));
  };
  img.src = URL.createObjectURL(file);
});

export const ImagePicker = ({ value, onChange }) => (
  <div>
    {value ? (
      <div className="relative w-full max-w-sm">
        <img src={value} alt="" className="rounded-xl aspect-[4/3] object-cover w-full" data-testid="image-preview" />
        <button type="button" onClick={() => onChange(null)} data-testid="image-remove-btn" className="absolute top-2 left-2 bg-white rounded-full p-1.5 shadow"><X size={16} /></button>
      </div>
    ) : (
      <label className="flex flex-col items-center justify-center gap-2 border-2 border-dashed rounded-xl h-40 max-w-sm cursor-pointer hover:border-brand text-slate-500 transition-colors">
        <ImagePlus /> <span className="text-sm">اضغط لرفع صورة</span>
        <input type="file" accept="image/*" className="hidden" data-testid="image-input" onChange={async (e) => e.target.files[0] && onChange(await resizeImage(e.target.files[0]))} />
      </label>
    )}
  </div>
);
